(function () {
  if (window.__hosHomeInit) return;
  window.__hosHomeInit = true;

  function initBuy(form) {
    if (form.__hos) return; form.__hos = true;
    var add = form.querySelector('.hos-buy__add');
    var msg = form.querySelector('.hos-buy__msg');
    var chosen = null;
    form.querySelectorAll('.hos-buy__size').forEach(function (b) {
      b.addEventListener('click', function () {
        form.querySelectorAll('.hos-buy__size').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        chosen = b.getAttribute('data-variant');
        add.disabled = false;
        add.textContent = 'Add to bag';
        msg.textContent = '';
      });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!chosen) return;
      add.disabled = true; add.textContent = 'Adding';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(chosen), quantity: 1 }], sections: 'cart-icon-bubble' })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not add this size');
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && res.d.sections && res.d.sections['cart-icon-bubble']) {
            var doc = new DOMParser().parseFromString(res.d.sections['cart-icon-bubble'], 'text/html');
            var inner = doc.querySelector('.shopify-section');
            if (inner) bubble.innerHTML = inner.innerHTML;
          }
          add.textContent = 'Added to bag';
          msg.innerHTML = 'Added. <a class="hos-link" href="/cart">View bag</a>';
          setTimeout(function () { add.disabled = false; add.textContent = 'Add to bag'; }, 2500);
        })
        .catch(function (err) {
          add.disabled = false; add.textContent = 'Add to bag';
          msg.textContent = err.message + '. Try another size.';
        });
    });
  }

  function initColours(root) {
    if (root.__hos) return; root.__hos = true;
    var imgs = root.querySelectorAll('[data-hc-img]');
    var name = root.querySelector('[data-hc-name]');
    var price = root.querySelector('[data-hc-price]');
    var rating = root.querySelector('[data-hc-rating]');
    var cta = root.querySelector('[data-hc-cta]');
    var link = root.querySelector('[data-hc-link-img]');
    var sw = root.querySelectorAll('.hos-colours__swatch');
    function pick(b) {
      var i = b.getAttribute('data-hc-i');
      sw.forEach(function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); x.tabIndex = x === b ? 0 : -1; });
      imgs.forEach(function (im) { im.classList.toggle('is-active', im.getAttribute('data-hc-img') === i); });
      name.textContent = b.dataset.name;
      price.textContent = b.dataset.price;
      rating.textContent = b.dataset.rating || '';
      cta.textContent = 'Shop ' + b.dataset.name;
      cta.href = b.dataset.url; link.href = b.dataset.url;
    }
    sw.forEach(function (b, idx) {
      b.tabIndex = b.getAttribute('aria-checked') === 'true' ? 0 : -1;
      b.addEventListener('click', function () { pick(b); });
      b.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = sw[(idx + 1) % sw.length];
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = sw[(idx - 1 + sw.length) % sw.length];
        if (n) { e.preventDefault(); pick(n); n.focus(); }
      });
    });
    var on = root.querySelector('.hos-colours__swatch[aria-checked="true"]') || sw[0]; if (on) rating.textContent = on.dataset.rating || '';
  }

  function initTabs(root) {
    if (root.__hos) return; root.__hos = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    function show(t) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(t); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); show(n); n.focus(); }
      });
    });
  }


  function initCarousel(root) {
    if (root.__hos) return; root.__hos = true;
    var track = root.querySelector('[data-car-track]');
    var slides = track.children;
    var dots = root.querySelectorAll('[data-car-dot]');
    var n = slides.length; if (n < 2) return;
    var secs = parseInt(root.getAttribute('data-interval') || '0', 10);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var idx = 0, timer = null, pausedUntil = 0, hovering = false;
    function current() { return Math.round(track.scrollLeft / track.clientWidth); }
    function setDots(c) { dots.forEach(function (d, j) { d.setAttribute('aria-current', j === c ? 'true' : 'false'); }); }
    function go(i) { idx = (i + n) % n; setDots(idx); track.scrollTo({ left: idx * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
    function sync() { idx = current(); setDots(idx); }
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 150); }, { passive: true });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { pause(); go(j); }); });
    var prev = root.querySelector('[data-car-prev]'), next = root.querySelector('[data-car-next]');
    if (prev) prev.addEventListener('click', function () { pause(); go(idx - 1); });
    if (next) next.addEventListener('click', function () { pause(); go(idx + 1); });
    function pause() { pausedUntil = Date.now() + 12000; }
    track.addEventListener('touchstart', pause, { passive: true });
    root.addEventListener('mouseenter', function () { hovering = true; });
    root.addEventListener('mouseleave', function () { hovering = false; });
    root.addEventListener('focusin', pause);
    window.addEventListener('resize', function () { track.scrollLeft = idx * track.clientWidth; });
    if (secs > 0 && !reduce) {
      timer = setInterval(function () {
        if (hovering || document.hidden || Date.now() < pausedUntil) return;
        var r = root.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) return;
        go(idx + 1);
      }, secs * 1000);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-hos-buy]').forEach(initBuy);
    document.querySelectorAll('[data-hos-colours]').forEach(initColours);
    document.querySelectorAll('[data-hos-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-hos-car]').forEach(initCarousel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function () { window.__hosHomeInit && initAll(); });
})();
